import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import orderCollectorService from "services/orderCollectorService";

export const useListOrderCollector = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["allocateCollector"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["order-collector", params?.page],
    () => orderCollectorService.listOrderCollector(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("order_collector"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;

        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListCollectorOfHub = (payload, onSuccess, onError) => {
  const { params } = payload;

  return useQuery(
    ["hub-collector", params?.page],
    () => orderCollectorService.listCollectorOfHub(params),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      select: response => response.data,
    }
  );
};

export const useCollectorLocationHub = payload => {
  const { params } = payload;

  return useQuery({
    enabled: false,
    queryKey: ["collector-location-hub", params],
    queryFn: () => orderCollectorService.collectorLocationHub(params),
    select: response => response.data,
  });
};
